import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useMemo, useState } from 'react';

import liff from '@line/liff';

import { useCollection } from 'react-firebase-hooks/firestore';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Grid,
} from '@mui/material';
// components
import UserService from '../services/user.service';
import { groupArrayBy, isLocalhost, statParams } from '../App';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import AppCurrentRegister from '../sections/@dashboard/app/AppCurrentRegister';
import AppHorizonalBar from '../sections/@dashboard/app/AppHorizonalBar';
import AppBarChartHorizongtalLabel from '../sections/@dashboard/app/AppBarChartHorizongtalLabel';
import AppTreemap from '../sections/@dashboard/app/AppTreemap';
import AppPolarAreaChart from '../sections/@dashboard/app/AppPolarAreaChart';
import RoleConfirmation from '../layouts/userpage/RoleConfirmation';
// mock
// import USERLIST from '../_mock/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'rank', label: 'ยศ', alignRight: false },
  { id: 'name', label: 'ชื่อ', alignRight: false },
  { id: 'surname', label: 'นามสกุล', alignRight: false },
  { id: 'type', label: 'ประเภทกำลังพล', alignRight: false },
  { id: 'unit', label: 'หน่วย', alignRight: false },
  { id: 'role', label: 'สถานะ', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 || _user.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1 || (_user.role && _user.role.toLowerCase().indexOf(query.toLowerCase()) !== -1));
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {

  const liffId = '1656457313-v140N5PP' // process.env.REACT_APP_LIFF_ID

  const [profile, setProfile] = useState({});

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [editingUser, setEditingUser] = useState(null);

  const [openRoleDialog, setOpenRoleDialog] = useState(false);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [users, setUsers] = useState([]);


  const [dbUsers, loadingUsers, errorGetUsers] = useCollection(UserService.getAllRegisteredUsers())


async function getLineProfile() {
  const profile = await liff.getProfile()
  return profile
}


  useEffect(() => {

    // console.log(dbUsers.docs.length);
    if (dbUsers && dbUsers.docs.length) {

      setUsers(dbUsers.docs.filter(u => u.data().type).map((u, index) => ({id: index, ...u.data(), unit: u.data().unit.abbr || u.data().unit})))
      // setUsersStats(o => ({
      //   ...o,
      //   ...
      // }))


    }
  }, [dbUsers]);

  const updateUserProfile = async (data) => {
    UserService.updateUserProfile(data)
    .then(r => r)
    .catch(e => console.log(e))
  }

  const usersStats = useMemo(() => {

    if (users && users.length) {
      return Object.entries(statParams).reduce((p, [field, value]) => ({
        ...p,
        [field] : {
          ...value,
          data: groupArrayBy(users, field),
          chartname: field
        }
      }), statParams)
    }
    return statParams
  }, [users])


  const statsGrid = useMemo(() => (<Grid container spacing={3}>
      {Object.entries(usersStats)
      .map(([key, stat]) => {

        const { name, chartname } = stat
        const chartData = Object.entries(stat.data).map(([label, items]) => ({label, value: items.length}))

        switch (stat.charttype) {

          case 'horizontalbar':
            return (<Grid key={key} item xs={12} md={stat.grid.md || 6} lg={stat.grid.lg || 4}>
              <AppHorizonalBar
              title={name}
              chartname={chartname}
              // subheader="(+43%) than last year"
              chartColors={[
                // theme.palette.primary.main,
                // theme.palette.info.main,
                // theme.palette.warning.main,
                // theme.palette.error.main,
              ]}
              chartData={chartData}

            />

            {/* <AppBarChartHorizongtalLabel /> */}

            </Grid>)

          case 'polarArea':
            return (<Grid key={key} item xs={12} md={stat.grid.md || 6} lg={stat.grid.lg || 4}>
              <AppPolarAreaChart
              title={name}
              chartname={chartname}
              // subheader="(+43%) than last year"
              chartColors={[
                // theme.palette.primary.main,
                // theme.palette.info.main,
                // theme.palette.warning.main,
                // theme.palette.error.main,
              ]}
              chartData={chartData}

            />

            {/* <AppBarChartHorizongtalLabel /> */}

            </Grid>)

          case 'treemap':
            return (<Grid key={key} item xs={12} md={stat.grid.md || 6} lg={stat.grid.lg || 4}>
              <AppTreemap
              chartname={chartname}
              title={name}
              chartData={chartData}
            /></Grid>)

          default:
            return (<Grid key={key} item xs={12} md={stat.grid.md || 6} lg={stat.grid.lg || 4}>
            <AppCurrentRegister
              title={name}
              chartname={chartname}
              chartData={chartData}
              chartColors={[
                // theme.palette.primary.main,
                // theme.palette.info.main,
                // theme.palette.warning.main,
                // theme.palette.error.main,
              ]}
            />
          </Grid>)
        }})}
    </Grid>), [usersStats])


  // useEffect(() => {

  //   console.log(usersStats);

  // }, [usersStats])



  useEffect(() => {


    // let user
    if (isLocalhost) {

        const profile = {
          userId: 'abc',
          displayName: 'Chaloemphol',
          statusMessage: 'ev’ry moment new',
          pictureUrl: '/assets/images/avatars/avatar_2.jpg',
        }
        setProfile(profile)
    // })
      return undefined
    }

    (async () => {

    //   if (isLocalhost) return
    await liff.init({ liffId, withLoginOnExternalBrowser: true})

    if (!liff.isInClient() && !liff.isLoggedIn()) {
      liff.login()
    }
    await getLineProfile()
      .then( data => {

        setProfile(data)

      })


    })()

    return undefined
  }, []);


  const handleOpenMenu = (event, user) => {
    setEditingUser(user)
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    // setEditingUser(null)
    setOpen(null);
  };


  const handleCloseRoleDialog = (newRole) => {
    console.log('newRole', newRole);
    const data = {
      user: {
        ...editingUser,
        role: newRole        
      }
    }
    updateUserProfile(data)
    .then(r => {      
      console.log('r', r);
      setEditingUser(null);
    })
    .finally(setOpenRoleDialog(false));
  };



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  useEffect(() => {
    console.log('editingUser', editingUser);
  }, [editingUser]);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  if (!profile || (profile && profile.userId !== 'U67d5edbddf731e4ee9929b3ede7dc6ef')) return (<></>)
  return (
    <>
      <Helmet>
        <title> User | The Runway </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={5}>
          <Typography variant="h4" gutterBottom>
            ผู้ใช้
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="solar:refresh-linear" />} onClick={() => {}}>
            Refresh
          </Button>
        </Stack>

        {statsGrid}

        {!loadingUsers &&  !errorGetUsers && dbUsers && dbUsers.docs && <Typography variant='caption'>จำนวนผู้ป้อนข้อมูลแล้ว {users.length} คน</Typography>}


        {/* คิดเป็น {(100 * users.length / dbUsers.docs.length).toFixed(0)}% จากผู้ที่เคยมาใช้งานทั้งหมด {dbUsers.docs.length} คน */}


        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={users.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, rank, pictureUrl, displayName, name, surname, type, unit, role } = row;
                    const selectedUser = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell>

                        <TableCell align="left">{rank}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={name} src={pictureUrl} />
                            <Stack direction="column" alignItems="left" spacing={0}>
                            <Typography variant="subtitle2" noWrap>
                                {name}
                              </Typography>
                              <Typography variant="caption" color={'text.secondary'} noWrap>
                                {displayName}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{surname}</TableCell>

                        <TableCell align="left">{type}</TableCell>

                        <TableCell align="left">{unit}</TableCell>

                        <TableCell align="left">{role}</TableCell>


                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(event) => handleOpenMenu(event, row)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={users.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => setOpenRoleDialog(true)}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Role
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      <RoleConfirmation
        id="role-menu"
        keepMounted
        open={openRoleDialog}
        onClose={handleCloseRoleDialog}
        value={editingUser && editingUser.role}
      />
    </>
  );
}
